// @flow
import { useSelector } from 'react-redux';
import { gql, useQuery } from '@apollo/client';
import * as selectors from '../selectors';

type UsePendingDeployment = () => {
  pendingDeployment: Object,
  isFetching: boolean,
  refetchPendingDeployment: () => void
}

const usePendingDeployment: UsePendingDeployment = () => {
  const { data, loading, refetch } = useQuery(QUERY)

  const { pendingDeployment } = useSelector(mapStateToProps(data));

  return {
    pendingDeployment,
    isFetching: loading,
    refetchPendingDeployment: refetch
  };
};

/* =============================================================================
=    GraphQL
============================================================================= */
const pageFields = `
  _id
  title
  path
  publishedVersion
  commitedVersion
  updatedAt
  updatedBy
  category {
    title
    updated
  }
  versions {
    _id
    versionId
    updatedAt
    updatedBy
    notes
    template {
      version
    }
  }
`;

const QUERY = gql`
query getPendingDeployment {
  pendingDeployment {
    added {
      ${pageFields}
    }
    deleted {
      ${pageFields}
    }
    removed {
      ${pageFields}
    }
  }
}
`;

/* =============================================================================
=    Redux
============================================================================= */
const mapStateToProps = (ownProps) => (state) => ({
  pendingDeployment: selectors.selectPendingDeploymentWithDiff(state, ownProps)
});

export default usePendingDeployment;
